import cn from 'classnames';
import _ from 'lodash';
import { useCallback, useState } from 'react';
import readXlsxFile from 'read-excel-file';
import { TYPE_BUTTONS } from '../../../../../constans';
import { showSuccessNotify } from '../../../../../utils/Notiffication';
import { Column, Row, WhiteBlock } from '../../../Blocks';
import Button from '../../Button';
import ExportExcelFileButton from '../ExcelExportFile';
import styles from './styles.module.scss';
import { Text } from '../../../WrapsStyle';

const ImportExcelKdvButton = ({
  width = 'default',
  height = '36px',
  style,
  onChange = (_) => _,
  redButton = false,
  children,
  sliceLine = 1,
  ...props
}) => {

  let [excel, setExcel] = useState([]);
  const parseData = async (files) => {
    let array = [];

    const readFileOne = async (file, i) => {
      return await readXlsxFile(file).then((rows) => {
        let keys = {};
        rows[27].forEach((item, key) => {
          keys[key] = item;
        }); // забираем наименование столбцов с шапки


        console.log(keys)
        const data = rows
          .slice(28)
          .map((d) => {
            const row = {};
            d.forEach((item, key) => {
              row[keys[key]] = item;
            });
            return row;
          })
          .filter((item) => item['3'] != 'null' && item['3'] !== null && item['2'].length > 2 && item['3'] != 'код');

        console.log(data)
        const true_data = data.map((item) => ({
          Артикул: `kdv-${item['3']}`,
          Наименование: item['2'],
          'Ставка НДС': item['14'],
          'Единица измерения': item['4'],
        }));

        console.log(true_data)

        showSuccessNotify(`Файл ${i + 1} обработан`);

        array.push(...true_data);
        return true_data;
      });
    };

    let files_array = Array.from(files);
    for (let i = 0; i < files_array.length; i++) {
      let res = await readFileOne(files_array[i], i);
      array.push(res);
    }

    let new_excel = _.uniqBy([...excel, ...array], 'Артикул').filter((item) => item['Артикул']?.length > 2);
    setExcel(new_excel);
  };

  const onLoad = async (e) => {
    let files = e.target.files;

    console.log(files);
    parseData(files);
    e.target.value = null;
  };

  const calcDownloadedData = useCallback(() => {
    return excel;
  }, [excel]);


  return (
    <Column>
      <WhiteBlock title='Обработка яшкино'>
        <Row style={{ marginTop: '15px' }}>
          <label style={{ width, height, ...style }}>
            <span className={cn(styles.button_base, styles.button_green, redButton && styles.button_red, props.styles)}>
              Загрузить файлы
            </span>
            <input type="file" className={styles.input} onChange={(e) => onLoad(e)} multiple />
          </label>

          <ExportExcelFileButton
            style={{ marginLeft: '15px' }}
            filename={`Номенклатруа яшкино ${excel.length}`}
            data={{
              'Заказ общий': calcDownloadedData(),
            }}
            buttonTitle={`Скачать номенклатуру яшкино`}
          />
          <Button type={TYPE_BUTTONS.RED} style={{ marginLeft: '15px' }} onClick={() => setExcel([])}>
            Очистить
          </Button>
        </Row>

        <Text style={{ marginTop: '15px' }}>{`Обработанно: ${excel.length}`}</Text>
      </WhiteBlock>
    </Column>
  );
};

export default ImportExcelKdvButton;
